var nlsdomain = "https://localhost:44350";
var clubListEndPoint = nlsdomain + "/api/v2/ClubApi/ClubList";
var clubList = clubListEndPoint;
var clubDetailEndPoint = nlsdomain + "/api/v2/ClubApi/ClubDetail/";
var pyramidDetails = nlsdomain + "/api/PyramidApi/GetPyramid";
var updateClubPyramidApi = nlsdomain + "/api/ClubApi/UpdateClubPyramid";
var addClubApi = nlsdomain + "/api/v2/ClubApi/AddClub";
var addClubBasicSocialApi = nlsdomain + "/api/v2/ClubApi/AddClubBasicSocial";
var blogPosts = nlsdomain + "/api/BlogApi/BlogEntryList";
var updateBlogPostIsPublished = nlsdomain + "/api/BlogApi/BlogEntrySetPublished";
var createNewBlogPost = nlsdomain + "/api/BlogApi/CreateBlogEntry";
var testCreateNewBlogPost = nlsdomain + "/api/BlogApi/TestCreateBlogEntry";
var createImmediateTwitterPost = nlsdomain + "/api/TwitterApi/AddImmediateTweet";

export { addClubApi, addClubBasicSocialApi, blogPosts, clubDetailEndPoint, clubList, clubListEndPoint, createImmediateTwitterPost, createNewBlogPost, nlsdomain, pyramidDetails, testCreateNewBlogPost, updateBlogPostIsPublished, updateClubPyramidApi };
//# sourceMappingURL=apiConsts.js.map
